import { Injectable, inject } from '@angular/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { PlatformService } from './platform.service';
import { LoggingService } from './logging.service';

@Injectable({ providedIn: 'root' })
export class HapticsService {
  private readonly platform = inject(PlatformService);
  private readonly loggingService = inject(LoggingService);

  async tap(): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: tap failed');
    }
  }

  async medium(): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.impact({ style: ImpactStyle.Medium });
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: medium failed');
    }
  }

  async heavy(): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.impact({ style: ImpactStyle.Heavy });
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: heavy failed');
    }
  }

  async success(): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.notification({ type: NotificationType.Success });
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: success failed');
    }
  }

  async error(): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.notification({ type: NotificationType.Error });
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: error failed');
    }
  }

  async warning(): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.notification({ type: NotificationType.Warning });
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: warning failed');
    }
  }

  async selectionChanged(): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.selectionChanged();
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: selectionChanged failed');
    }
  }

  async selectionStart(): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.selectionStart();
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: selectionStart failed');
    }
  }

  async selectionEnd(): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.selectionEnd();
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: selectionEnd failed');
    }
  }

  async vibrate(duration = 300): Promise<void> {
    if (!this.platform.isNativeMobile()) return;

    try {
      await Haptics.vibrate({ duration });
    } catch (error) {
      this.loggingService.logException(error, 'HapticsService: vibrate failed');
    }
  }
}
